export const COLLECTION_GOT = 'COLLECTION_GOT'
export const PRODUCT_PENDING_ID = 'PRODUCT_PENDING_ID'
export const PRODUCT_PENDING_ID_STOP = 'PRODUCT_PENDING_ID_STOP'
export const PRODUCT_TRANSLATION_GOT = 'PRODUCT_TRANSLATION_GOT'
export const PRODUCTS_TO_TRANSLATE_GET = 'PRODUCTS_TO_TRANSLATE_GET'
export const VENDOR_DATA_GOT = 'VENDOR_DATA_GOT'
